/* SpawnAnything — UI theme switch while the three "Comic, aber ruhig" directions are compared (labs/ui-entwurf.html).
   html[data-ui] = a | b | c (src/ui/theme.css); 'alt' = the previous dark look (no attribute). Choice in the panel foot
   ("Oberfläche") or with the U key; remembered per browser. */
import './theme.css';

export const UI_THEMES = [
  ['a', 'A · Zeitungscomic'],
  ['b', 'B · Nacht-Heft'],
  ['c', 'C · Klare Linie'],
  ['alt', 'Bisher (dunkel)'],
];
const KEY = 'aw-ui';
let cur = 'a';
try { const k = localStorage.getItem(KEY); if (UI_THEMES.some(t => t[0] === k)) cur = k; } catch (e) { /* private mode */ }

function apply(k) {
  cur = k;
  if (k === 'alt') delete document.documentElement.dataset.ui; else document.documentElement.dataset.ui = k;
  try { localStorage.setItem(KEY, k); } catch (e) { /* private mode */ }
  const sel = document.getElementById('uiTheme'); if (sel) sel.value = k;
}
apply(cur); // at import time, before the first frame

/** Adds the "Oberfläche" select to the panel foot and the U shortcut. toast(text) shows the new name. */
export function initThemeSwitch(toast) {
  const foot = document.querySelector('#settingsWin .foot, #panel .foot');
  if (foot && !document.getElementById('uiTheme')) {
    const row = document.createElement('div'); row.className = 'ui-pick';
    row.innerHTML = `<label for="uiTheme">Design</label><select class="qsel" id="uiTheme">${UI_THEMES.map(([k, n]) => `<option value="${k}">${n}</option>`).join('')}</select>`;
    foot.prepend(row);
    const sel = row.querySelector('select'); sel.value = cur;
    sel.addEventListener('change', () => apply(sel.value));
  }
  addEventListener('keydown', e => {
    if (e.key !== 'u' && e.key !== 'U') return;
    if (e.ctrlKey || e.metaKey || e.altKey || e.target.closest?.('input,textarea,select,[contenteditable]')) return;
    const i = UI_THEMES.findIndex(t => t[0] === cur), next = UI_THEMES[(i + 1) % UI_THEMES.length];
    apply(next[0]);
    if (toast) toast('Design: ' + next[1] + ' (Taste U wechselt)');
  });
}
